import { render } from "./Beanie_1_back.vue?vue&type=template&id=7ac8f4b5"
import script from "./Beanie_1_back.vue?vue&type=script&lang=js"
export * from "./Beanie_1_back.vue?vue&type=script&lang=js"

import exportComponent from "/srv/users/dyo-frontend-staging/apps/dyo-frontend-staging/public_html/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__